export const ENVIRONMENT = import.meta.env.VITE_CALIZA_CUSTOMER_DASHBOARD_ENVIRONMENT;
export const KEYCLOAK_UNIVERSAL_FORM_ID = 'keycloak-form';
export const HIGH_PRECISION_DECIMAL_PLACES = 7;
export const IS_PRODUCTION_ENVIRONMENT = ENVIRONMENT === 'production';
export const IS_DEVELOPMENT_ENVIRONMENT = ENVIRONMENT === 'develop';
export const IS_PREVIEW_PRODUCTION_ENVIRONMENT = ENVIRONMENT === 'preview-production';
export const IS_LOCAL_ENVIRONMENT = ENVIRONMENT === 'local';
export const IS_PREVIEW_DEVELOPMENT_ENVIRONMENT = ENVIRONMENT === 'preview-develop';
export const SHOULD_MOCK_DEPOSITS =
  IS_LOCAL_ENVIRONMENT || IS_PREVIEW_DEVELOPMENT_ENVIRONMENT || IS_DEVELOPMENT_ENVIRONMENT;
const WEBFLOW_CDN_BASE_URL = 'https://cdn.prod.website-files.com/677ed676bd7257ea423799b4';
export const TERMS_AND_CONDITIONS_URL = `${WEBFLOW_CDN_BASE_URL}/698a65228a40377068a5de2e_Caliza%20Customer%20Terms%20and%20Conditions%20USA%202026.docx.pdf`;
export const PRIVACY_POLICY_URL = `${WEBFLOW_CDN_BASE_URL}/698a6522f0a64bd8dedb0942_Caliza%20US%20Privacy%20Policy%20-%20Final%2002.06.2026.docx.pdf`;
export const AML_POLICY_URL = `${WEBFLOW_CDN_BASE_URL}/698a6522c52f032df11ef490_Caliza%20AML%20Compliance%20Program%202026.docx.pdf`;
